import React from "react"
import { Link } from "gatsby"

import { AuthUserContext } from "../Session"
import SignOutButton from "../SignOut"
import * as ROUTES from "../../constants/routes"
import * as ROLES from "../../constants/roles"

const Navigation = () => (
  <AuthUserContext.Consumer>
    {authUser =>
      authUser ? <NavigationAuth authUser={authUser} /> : <NavigationNonAuth />
    }
  </AuthUserContext.Consumer>
)

const NavigationAuth = ({ authUser }) => (
  <ul>
    <li>
      <Link to={ROUTES.HOME}>Home</Link>
    </li>
    <li>
      <Link to={authUser.completed ? ROUTES.RESULTS : ROUTES.QUESTIONNAIRE}>
        {authUser.completed ? "Results" : "Questionnaire"}
      </Link>
    </li>
    <li>
      <Link to={ROUTES.PASSWORD_RESET + "?uid=" + authUser.uid}>
        Reset Password
      </Link>
    </li>
    {authUser.roles[ROLES.ADMIN] && (
      <li>
        <Link to={ROUTES.ADMIN}>Admin</Link>
      </li>
    )}
    <li>
      <SignOutButton />
    </li>
  </ul>
)

const NavigationNonAuth = () => (
  <ul>
    <li>
      <Link to={ROUTES.HOME}>Home</Link>
    </li>
    <li>
      <Link to={ROUTES.SIGN_IN}>Sign up / Sign In</Link>
    </li>
  </ul>
)

export default Navigation
